import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import 'SRC/static/styles/reset.scss';

ReactDOM.render(<App />, document.getElementById('root'));
